import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import Tooltip from 'components/Tooltip';
import { withModal } from 'components/modal/ModalHOC';

import ListsCreateEditModal from 'modules/lists/components/ListsCreateEditModal';
import DiscoveryCreatorsFilterPopover from 'modules/freemium/components/discovery-creators-filter-popover/DiscoveryCreatorsFilterPopover';

import { __t, applyTranslations } from 'utils/language';

import './creator-tile-save-to-collection.scss';

applyTranslations(require('./creator-tile-save-to-collection.i18n.json'));

type Props = {
  orgId: number,
  show: boolean,
  isSavingToList: boolean,
  isFreemium: boolean,
  onSaveSearchToList: (c: string, b: string, a: number) => void
};

const TooltipWithModal = withModal(Tooltip, {
  modalContent: ListsCreateEditModal
});

const msgKey = 'creator_tile_save_to_collection';

const CreatorTileSaveToCollection = ({
  orgId,
  show,
  isSavingToList,
  isFreemium,
  onSaveSearchToList
}: Props): JSX.Element => {
  const containerClasses = classnames('creator-tile-save-to-collection', {
    'creator-tile-save-to-collection--show': show,
    'creator-tile-save-to-collection--is-saving': isSavingToList
  });

  const renderIconPopover = (children: React.ReactNode): JSX.Element => (
    <div className={containerClasses}>
      <DiscoveryCreatorsFilterPopover
        triggerComponent={children}
      />
    </div>
  );

  const renderIcon = (): React.ReactNode => (
    <SVGDynamicIcon
      name="list-custom-bg"
      width={14}
      height={14}
      customColor="grey"
      clickable={!isSavingToList && !isFreemium}
    />
  );

  if (isFreemium) {
    return renderIconPopover(renderIcon());
  }

  return (
    <div className={containerClasses}>
      <TooltipWithModal
        modalContentProps={{
          title: __t(`${msgKey}.labels.create_new_collection`),
          organizationId: orgId,
          onSaveSearchToList
        }}
        message={__t(`${msgKey}.labels.add_results_to_collection`)}
        display="flex"
        width="auto-compact"
      >
        {renderIcon()}
      </TooltipWithModal>
    </div>
  );
};

export default CreatorTileSaveToCollection;
